import { SecurityType } from '@interfaces/models';
import {
  AANAccountType,
  FilteredAccount,
  FilteredClientAccount,
  IClientAccounts,
  MarginCode,
  OptionPermission,
  Position,
  ProductType,
} from '@interfaces/models/client-accounts.interface';
import { ISelectedAccount } from '@store/reducers/selected-client-accounts/selected-client-accounts.reducer';

export const simpleclientAccountTestStub: IClientAccounts = {
  vgClientPoid: null as unknown as string,
  accounts: [],
  serviceAgreements: [],
};

export const mixedAccountStub: IClientAccounts['accounts'] = [
  {
    accountId: '933930914141253',
    accountName: 'Isabella Taylor — Brokerage Account — 37089792',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '722886914141253',
    balance: '776656.83',
    accountType: AANAccountType.INDIVIDUAL,
    registrationType: '00',
    registrationSubType: '00',
    brokerageAccountNumber: '37089792',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '108016914141254',
        price: 1000.0,
        balance: 2107.45,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '318101929054956',
        price: 1000.0,
        balance: 45800.0,
        ticker: 'VPTXX',
        securityName: 'VANGUARD PENNSYLVANIA MUN MONEY MARKET INVESTOR CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '413408911042734',
        price: 1000.0,
        balance: 727950.0,
        ticker: 'AAPL',
        securityName: 'APPLE',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.STOCK,
        restricted: false,
      },
      {
        positionId: '819820119053811',
        price: 1000.0,
        balance: 799.38,
        ticker: 'VTI',
        securityName: 'VANGUARD TOTAL STOCK MARKET ETF',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.ETF,
        restricted: false,
      },
    ],
  },
  {
    accountId: '887355828125120',
    accountName: 'Benjamin Price, Isabella Taylor',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '208298828125120',
    balance: '10.00',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    registrationType: '01',
    registrationSubType: '03',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '882709152800040',
        price: 1000.0,
        balance: 0,
        ticker: null as unknown as string,
        securityName: null as unknown as string,
        shareQuantity: 0.0,
        vastAccountNumber: '88270915280',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '882709152800540',
        price: 1000.0,
        balance: 0.0,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 0.0,
        vastAccountNumber: '88270915280',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
    ],
  },
];

export const mixedServiceStub: IClientAccounts['serviceAgreements'] = [
  {
    serviceAgreementId: 722886914141253,
    serviceId: '90',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH2',
        permissionType: 'TRNS2',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 208298828125120,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 600946246,
        roleType: 'SHJS',
        permissionType: 'TRNS',
        primaryOwner: true,
        authorizedSigner: true,
      },
      {
        poid: 111111111,
        roleType: 'SHJS',
        permissionType: 'TRNS',
        primaryOwner: false,
        authorizedSigner: true,
      },
    ],
  },
];

export const mixedClientAccountTestStub: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: mixedAccountStub,
  serviceAgreements: mixedServiceStub,
};

export const individualAccountStub: IClientAccounts['accounts'] = [
  {
    accountId: '245592816134454',
    accountName: 'Isabella Taylor',
    productType: ProductType.MUTUAL_FUND,
    serviceAgreementId: '73569816134454',
    balance: '410136.69',
    accountType: AANAccountType.INDIVIDUAL,
    registrationType: '00',
    registrationSubType: '00',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '883743523670033',
        price: 1000.0,
        balance: 386732.42,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        vastAccountNumber: '88374352367',
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '883743523670033',
        price: 1000.0,
        balance: 386732.42,
        ticker: 'VUSXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        vastAccountNumber: '88374352367',
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '883743523670540',
        price: 1000.0,
        balance: 23404.27,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 129.737,
        vastAccountNumber: '88374352367',
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
    nickname: "Isabella's Account",
  },
  {
    accountId: '933930914141253',
    accountName: 'Isabella Taylor — Brokerage Account — 37089792',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '722886914141253',
    balance: '776656.83',
    accountType: AANAccountType.INDIVIDUAL,
    registrationType: '00',
    registrationSubType: '00',
    brokerageAccountNumber: '37089792',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '108016914141254',
        price: 1000.0,
        balance: 2107.45,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '318101929054956',
        price: 1000.0,
        balance: 45800.0,
        ticker: 'VPTXX',
        securityName: 'VANGUARD PENNSYLVANIA MUN MONEY MARKET INVESTOR CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '413408911042734',
        price: 1000.0,
        balance: 727950.0,
        ticker: 'AAPL',
        securityName: 'APPLE',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.STOCK,
        restricted: false,
      },
      {
        positionId: '819820119053811',
        price: 1000.0,
        balance: 799.38,
        ticker: 'VTI',
        securityName: 'VANGUARD TOTAL STOCK MARKET ETF',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.ETF,
        restricted: false,
      },
    ],
  },
  {
    accountId: '494446104144543',
    accountName: 'Isabella Taylor — Roth IRA Brokerage Account — 60917441',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '469090808101044',
    balance: '2251.48',
    accountType: AANAccountType.ROTH_IRA,
    registrationType: '00',
    registrationSubType: '47',
    brokerageAccountNumber: '60917441',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '59240120034314',
        price: 1000.0,
        balance: 13.36,
        ticker: 'EIISX',
        securityName: 'SOME COOL FUN',
        shareQuantity: 342.03,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '826290120112416',
        price: 1000.0,
        balance: 2232.06,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '967514104144543',
        price: 1000.0,
        balance: 6.06,
        ticker: 'APPL',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
];

export const individualAccountStubWithNoMoneyMarket: IClientAccounts['accounts'] = [
  {
    accountId: '245592816134454',
    accountName: 'Isabella Taylor',
    productType: ProductType.MUTUAL_FUND,
    serviceAgreementId: '73569816134454',
    balance: '410136.69',
    accountType: AANAccountType.INDIVIDUAL,
    registrationType: '00',
    registrationSubType: '00',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '883743523670033',
        price: 1000.0,
        balance: 386732.42,
        ticker: 'APPL',
        securityName: 'APPLE INC',
        shareQuantity: 8492203.03,
        vastAccountNumber: '88374352367',
        securityType: SecurityType.STOCK,
        restricted: false,
      },
      {
        positionId: '883743523670540',
        price: 1000.0,
        balance: 23404.27,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 129.737,
        vastAccountNumber: '88374352367',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
    ],
    nickname: "Isabella's Account",
  },
  {
    accountId: '933930914141253',
    accountName: 'Isabella Taylor — Brokerage Account — 37089792',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '722886914141253',
    balance: '776656.83',
    accountType: AANAccountType.INDIVIDUAL,
    registrationType: '00',
    registrationSubType: '00',
    brokerageAccountNumber: '37089792',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '108016914141254',
        price: 1000.0,
        balance: 2107.45,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '318101929054956',
        price: 1000.0,
        balance: 45800.0,
        ticker: 'VPTXX',
        securityName: 'VANGUARD PENNSYLVANIA MUN MONEY MARKET INVESTOR CL',
        shareQuantity: 129.73701,
        settlementFund: false,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '413408911042734',
        price: 1000.0,
        balance: 727950.0,
        ticker: 'AAPL',
        securityName: 'APPLE',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.STOCK,
        restricted: false,
      },
      {
        positionId: '819820119053811',
        price: 1000.0,
        balance: 799.38,
        ticker: 'VTI',
        securityName: 'VANGUARD TOTAL STOCK MARKET ETF',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.ETF,
        restricted: false,
      },
    ],
  },
  {
    accountId: '494446104144543',
    accountName: 'Isabella Taylor — Roth IRA Brokerage Account — 60917441',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '469090808101044',
    balance: '2251.48',
    accountType: AANAccountType.ROTH_IRA,
    registrationType: '00',
    registrationSubType: '47',
    brokerageAccountNumber: '60917441',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '59240120034314',
        price: 1000.0,
        balance: 13.36,
        ticker: 'EIISX',
        securityName: 'SOME COOL FUN',
        shareQuantity: 342.03,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '826290120112416',
        price: 1000.0,
        balance: 2232.06,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '967514104144543',
        price: 1000.0,
        balance: 6.06,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
];

export const individualAccountStub2Accounts: IClientAccounts['accounts'] = [
  {
    accountId: '933930914141253',
    accountName: 'Isabella Taylor — Brokerage Account — 37089792',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '722886914141253',
    balance: '776656.83',
    accountType: AANAccountType.INDIVIDUAL,
    registrationType: '00',
    registrationSubType: '00',
    brokerageAccountNumber: '37089792',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '108016914141254',
        price: 1000.0,
        balance: 2107.45,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '318101929054956',
        price: 1000.0,
        balance: 45800.0,
        ticker: 'VPTXX',
        securityName: 'VANGUARD PENNSYLVANIA MUN MONEY MARKET INVESTOR CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '413408911042734',
        price: 1000.0,
        balance: 727950.0,
        ticker: 'AAPL',
        securityName: 'APPLE',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.STOCK,
        restricted: false,
      },
      {
        positionId: '819820119053811',
        price: 1000.0,
        balance: 799.38,
        ticker: 'VTI',
        securityName: 'VANGUARD TOTAL STOCK MARKET ETF',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.ETF,
        restricted: false,
      },
    ],
  },
  {
    accountId: '453930914141238',
    accountName: 'Isabella Taylor — Brokerage Account — 37089215',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '722886914141253',
    balance: '237445.83',
    accountType: AANAccountType.INDIVIDUAL,
    registrationType: '00',
    registrationSubType: '00',
    brokerageAccountNumber: '37089215',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '108016914141254',
        price: 1000.0,
        balance: 2107.45,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '318101929054956',
        price: 1000.0,
        balance: 45800.0,
        ticker: 'VPTXX',
        securityName: 'VANGUARD PENNSYLVANIA MUN MONEY MARKET INVESTOR CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '413408911042734',
        price: 1000.0,
        balance: 727950.0,
        ticker: 'AAPL',
        securityName: 'APPLE',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.STOCK,
        restricted: false,
      },
      {
        positionId: '819820119053811',
        price: 1000.0,
        balance: 799.38,
        ticker: 'VTI',
        securityName: 'VANGUARD TOTAL STOCK MARKET ETF',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.ETF,
        restricted: false,
      },
    ],
  },
];

export const individualServiceStub: IClientAccounts['serviceAgreements'] = [
  {
    serviceAgreementId: 73569816134454,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH0',
        permissionType: 'TRNS0',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 469090808101044,
    serviceId: '38',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH1',
        permissionType: 'TRNS1',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 722886914141253,
    serviceId: '90',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH2',
        permissionType: 'TRNS2',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
];

export const individualClientAccountTestStub: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: individualAccountStub,
  serviceAgreements: individualServiceStub,
};

export const individualClientAccountTestStubNoMoneyMarket: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: individualAccountStubWithNoMoneyMarket,
  serviceAgreements: individualServiceStub,
};

export const individualClientAccountTestStub2Accounts: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: individualAccountStub2Accounts,
  serviceAgreements: individualServiceStub,
};

export const iraAccountStub: IClientAccounts['accounts'] = [
  {
    accountId: '52362017104310',
    accountName: 'Isabella Taylor — Traditional IRA Brokerage Account — 71210618',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '909826018101950',
    balance: '749983.58000',
    accountType: AANAccountType.TRADITIONAL_IRA,
    registrationType: '00',
    registrationSubType: '31',
    brokerageAccountNumber: '71210618',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '535582017130125',
        price: 1000.0,
        balance: 7485.96,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '561793126032030',
        price: 1000.0,
        balance: 737620.0,
        ticker: 'TSLA',
        securityName: 'TESLA INC',
        shareQuantity: 342.03,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '843442017104310',
        price: 1000.0,
        balance: 4877.62,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '149022130161844',
    accountName: 'Isabella Taylor — Rollover IRA Brokerage Account — 59748528',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '392096472819378',
    balance: '53.084',
    accountType: AANAccountType.ROLLOVER_IRA,
    registrationType: '00',
    registrationSubType: '47',
    brokerageAccountNumber: '59748528',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '38063130161844',
        price: 1000.0,
        balance: 0.0,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '149022130161844',
    accountName: 'Isabella Taylor — SEP IRA Brokerage Account — 59748528',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '909826018101950',
    balance: '0.01',
    accountType: AANAccountType.SEP_IRA_SINGLE_PARTICIPANT,
    registrationType: '00',
    registrationSubType: '47',
    brokerageAccountNumber: '59748528',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '38063130161844',
        price: 1000.0,
        balance: 0.0,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '149022130161844',
    accountName: 'Isabella Taylor — Roth IRA Brokerage Account — 59748528',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '378290765543562',
    balance: '92.04',
    accountType: AANAccountType.ROTH_IRA,
    registrationType: '00',
    registrationSubType: '47',
    brokerageAccountNumber: '59748528',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '38063130161844',
        price: 1000.0,
        balance: 0.0,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
];

export const iraServiceStub: IClientAccounts['serviceAgreements'] = [
  {
    serviceAgreementId: 909826018101950,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH0',
        permissionType: 'TRNS0',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 392096472819378,
    serviceId: '38',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH1',
        permissionType: 'TRNS1',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 909826018101950,
    serviceId: '90',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH2',
        permissionType: 'TRNS2',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 378290765543562,
    serviceId: '90',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH3',
        permissionType: 'TRNS3',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
];

export const iraClientAccountTestStub: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: iraAccountStub,
  serviceAgreements: iraServiceStub,
};

export const jointAccountStub: IClientAccounts['accounts'] = [
  {
    accountId: '110429828123940',
    accountName: 'Isabella Taylor, Benjamin Price',
    productType: ProductType.MUTUAL_FUND,
    serviceAgreementId: '181366828123940',
    balance: '10.00',
    accountType: AANAccountType.JOINT_TENANTS_IN_COMMON,
    registrationType: '01',
    registrationSubType: '01',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '883780762830033',
        price: 1000.0,
        balance: 0.0,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        vastAccountNumber: '88378076283',
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '931239109153121',
    accountName: 'Isabella Taylor, Benjamin Price — Brokerage Account — 79027813',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '762180109153121',
    balance: '5009.62',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    registrationType: '01',
    registrationSubType: '03',
    brokerageAccountNumber: '79027813',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '637308109153121',
        price: 1000.0,
        balance: 5009.62,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '887355828125120',
    accountName: 'Benjamin Price, Isabella Taylor',
    productType: ProductType.MUTUAL_FUND,
    serviceAgreementId: '208298828125120',
    balance: '10.00',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    registrationType: '01',
    registrationSubType: '03',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '882709152800040',
        price: 1000.0,
        balance: 0,
        ticker: null as string,
        securityName: null as string,
        shareQuantity: 0.0,
        vastAccountNumber: '88270915280',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '882709152800540',
        price: 1000.0,
        balance: 0.0,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 0.0,
        vastAccountNumber: '88270915280',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountName: 'Test Client1, Test Client2 — Brokerage Account — 88888888',
    productType: ProductType.BROKERAGE,
    accountId: '999999999999999',
    serviceAgreementId: '111111111111111',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    balance: '99999.99',
    registrationType: '01',
    registrationSubType: '03',
    brokerageAccountNumber: '79027813',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '637308109153121',
        price: 1000.0,
        balance: 5009.62,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountName: 'Isabella Taylor, Benjamin Price — Brokerage Account — 37089792',
    productType: ProductType.BROKERAGE,
    accountId: '933930914141253',
    serviceAgreementId: '722886914141254',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    balance: '0',
    registrationType: '01',
    registrationSubType: '03',
    brokerageAccountNumber: '79027813',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '637308109153121',
        price: 1000.0,
        balance: 5009.62,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
];

export const jointAccountStubOneAccount: IClientAccounts['accounts'] = [
  {
    accountName: 'Isabella Taylor, Benjamin Price — Brokerage Account — 37089792',
    productType: ProductType.BROKERAGE,
    accountId: '933930914141253',
    serviceAgreementId: '722886914141254',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    balance: '0',
    registrationType: '01',
    registrationSubType: '03',
    brokerageAccountNumber: '79027813',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '637308109153121',
        price: 1000.0,
        balance: 5009.62,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
];

export const jointAccountStub2Accounts: IClientAccounts['accounts'] = [
  {
    accountId: '110429828123940',
    accountName: 'Isabella Taylor, Benjamin Price',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '181366828123940',
    balance: '10.00',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    registrationType: '01',
    registrationSubType: '01',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '883780762830033',
        price: 1000.0,
        balance: 0.0,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        vastAccountNumber: '88378076283',
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '931239109153121',
    accountName: 'Isabella Taylor, Benjamin Price — Brokerage Account — 79027813',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '762180109153121',
    balance: '5009.62',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    registrationType: '01',
    registrationSubType: '03',
    brokerageAccountNumber: '79027813',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '637308109153121',
        price: 1000.0,
        balance: 5009.62,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '887355828125120',
    accountName: 'Benjamin Price, Isabella Taylor',
    productType: ProductType.MUTUAL_FUND,
    serviceAgreementId: '208298828125120',
    balance: '10.00',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    registrationType: '01',
    registrationSubType: '03',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '882709152800040',
        price: 1000.0,
        balance: 0,
        ticker: null as unknown as string,
        securityName: null as unknown as string,
        shareQuantity: 0.0,
        vastAccountNumber: '88270915280',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '882709152800540',
        price: 1000.0,
        balance: 0.0,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 0.0,
        vastAccountNumber: '88270915280',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountName: 'Test Client1, Test Client2 — Brokerage Account — 88888888',
    productType: ProductType.BROKERAGE,
    accountId: '999999999999999',
    serviceAgreementId: '111111111111111',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    balance: '99999.99',
    registrationType: '01',
    registrationSubType: '03',
    brokerageAccountNumber: '79027813',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '637308109153121',
        price: 1000.0,
        balance: 5009.62,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountName: 'Isabella Taylor, Benjamin Price — Brokerage Account — 37089792',
    productType: ProductType.BROKERAGE,
    accountId: '933930914141253',
    serviceAgreementId: '722886914141254',
    accountType: AANAccountType.JOINT_TENANTS_WROS,
    balance: '0',
    registrationType: '01',
    registrationSubType: '03',
    brokerageAccountNumber: '79027813',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '637308109153121',
        price: 1000.0,
        balance: 5009.62,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
];

export const jointServiceStub: IClientAccounts['serviceAgreements'] = [
  {
    serviceAgreementId: 208298828125120,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 600946246,
        roleType: 'SHJS',
        permissionType: 'TRNS',
        primaryOwner: true,
        authorizedSigner: true,
      },
      {
        poid: 111111111,
        roleType: 'SHJS',
        permissionType: 'TRNS',
        primaryOwner: false,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 73569816134454,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH',
        permissionType: 'TRNS',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 181366828123940,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 600946246,
        roleType: 'SHJS',
        permissionType: 'TRNS',
        primaryOwner: false,
        authorizedSigner: true,
      },
      {
        poid: 111111111,
        roleType: 'SHJS',
        permissionType: 'TRNS',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 111111111111111,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 600946246,
        roleType: 'SHJS',
        permissionType: 'TRNS',
        primaryOwner: false,
        authorizedSigner: true,
      },
      {
        poid: 111111111,
        roleType: 'SHJS',
        permissionType: 'TRNS',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
];

export const jointClientAccountTestStubOneAccount: IClientAccounts = {
  vgClientPoid: '222111555',
  accounts: jointAccountStub,
  serviceAgreements: jointServiceStub,
};

export const jointClientAccountTestStub: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: jointAccountStub,
  serviceAgreements: jointServiceStub,
};

export const jointClientAccountTestStub2Accounts: IClientAccounts = {
  vgClientPoid: '111111555',
  accounts: jointAccountStub2Accounts,
  serviceAgreements: jointServiceStub,
};

export const filteredJointClientAccount: FilteredClientAccount = {
  vgClientPoid: '123',
  accounts: [
    {
      accountId: '887355828125120',
      accountName: 'Benjamin Price, Isabella Taylor',
      productType: ProductType.MUTUAL_FUND,
      isBrokerage: false,
      serviceAgreementId: '208298828125120',
      balance: '10.00',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      registrationType: '01',
      registrationSubType: '03',
      cashManagementAccount: false,
      accountNumber: '644',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: null,
      restrictions: [],
    },
    {
      accountId: '',
      accountName: 'T Client1, T Client2 — Brokerage Account — 88888888',
      productType: ProductType.BROKERAGE,
      isBrokerage: true,
      serviceAgreementId: '111111111111111',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      balance: '99999.99',
      accountNumber: '88888888',
      cashManagementAccount: false,
      registrationType: '',
      registrationSubType: '',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: null,
      restrictions: [],
    },
    {
      accountId: '887355828125120',
      accountName: 'BP, IT',
      productType: ProductType.MUTUAL_FUND,
      isBrokerage: false,
      serviceAgreementId: '4521',
      balance: '20.00',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      registrationType: '01',
      registrationSubType: '03',
      cashManagementAccount: false,
      accountNumber: '644',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: null,
      restrictions: [],
    },
    {
      accountName: 'Test Client1, Test Client2 — Brokerage Account — 88888888',
      productType: ProductType.BROKERAGE,
      accountId: '999999999999999',
      serviceAgreementId: '111111111111111',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      balance: '99999.99',
      registrationType: '01',
      registrationSubType: '03',
      accountNumber: '79027813',
      cashManagementAccount: false,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '637308109153121',
          price: 1000.0,
          balance: 5009.62,
          ticker: 'VMFXX',
          securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
          shareQuantity: 8492203.03,
          settlementFund: true,
          securityType: SecurityType.MONEY_MARKET_FUND,
          restricted: false,
        },
      ],
      isBrokerage: true,
      registeredRoles: [],
    },
  ],
};

export const filteredWithMoneyMarketHoldings: FilteredClientAccount = {
  vgClientPoid: '123',
  accounts: [
    {
      accountId: '933930914141253',
      accountName: 'Isabella Taylor — Brokerage Account — 346345646',
      productType: ProductType.BROKERAGE,
      serviceAgreementId: '72288691414453',
      balance: '776656.83',
      accountType: AANAccountType.INDIVIDUAL,
      registrationType: '00',
      registrationSubType: '00',
      accountNumber: '37089792',
      isBrokerage: true,
      cashManagementAccount: true,
      balanceAsOfDateTime: '2022-10-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '287520127130043',
          price: 1000.0,
          balance: 400393223.68,
          ticker: 'VMRXX',
          securityName: 'APPLE INC',
          shareQuantity: 8492203.03,
          settlementFund: false,
          securityType: SecurityType.MONEY_MARKET_FUND,
          restricted: false,
        },
        {
          positionId: '561793126032030',
          price: 1000.0,
          balance: 737620.0,
          ticker: 'VMSXX',
          securityName: 'TESLA INC',
          shareQuantity: 342.03,
          settlementFund: false,
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '287520127130043',
          price: 1000.0,
          balance: 400393223.68,
          ticker: 'TESLA',
          securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
          shareQuantity: 8492203.03,
          settlementFund: true,
          securityType: SecurityType.MONEY_MARKET_FUND,
          restricted: false,
        },
        {
          positionId: '287520127130043',
          price: 1000.0,
          balance: 400393223.68,
          ticker: 'SDDSS',
          securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
          shareQuantity: 8492203.03,
          settlementFund: true,
          securityType: SecurityType.MONEY_MARKET_FUND,
          restricted: false,
        },
      ],
    },
    {
      accountId: '933930914141253',
      accountName: 'Isabella Taylor — Brokerage Account — 37089792',
      productType: ProductType.BROKERAGE,
      serviceAgreementId: '722886914141253',
      balance: '776656.83',
      accountType: AANAccountType.INDIVIDUAL,
      registrationType: '00',
      registrationSubType: '00',
      accountNumber: '37089792',
      isBrokerage: true,
      cashManagementAccount: true,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '98935085740540',
          price: 1000.0,
          balance: 766049.32,
          ticker: 'VFIAX',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          settlementFund: true,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740541',
          price: 1000.0,
          balance: 6119.64,
          ticker: 'VWSUX',
          securityName: null,
          shareQuantity: 0.0,
          settlementFund: true,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740542',
          price: 1000.0,
          balance: 207935.3,
          ticker: 'VCTZZ',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          settlementFund: true,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740543',
          price: 1000.0,
          balance: 382117.18,
          ticker: 'VMSSS',
          securityName: null,
          settlementFund: true,
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
      ],
    },
  ],
};

export const filteredWithPositionsClientAccount: FilteredClientAccount = {
  vgClientPoid: '123',
  accounts: [
    {
      accountId: '887355828125120',
      accountName: 'Benjamin Price, Isabella Taylor',
      productType: ProductType.MUTUAL_FUND,
      isBrokerage: false,
      serviceAgreementId: '208298828125120',
      balance: '10.00',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      registrationType: '01',
      registrationSubType: '03',
      cashManagementAccount: false,
      accountNumber: '644232322',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '224665127130043',
          price: 1000.0,
          balance: 6562291.41,
          ticker: 'VGSTX',
          securityName: 'SOME COOL FUND',
          shareQuantity: 129.737,
          settlementFund: false,
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '561793126032030',
          price: 1000.0,
          balance: 737620.0,
          ticker: 'TSLA',
          securityName: 'TESLA INC',
          shareQuantity: 342.03,
          settlementFund: false,
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '287520127130043',
          price: 1000.0,
          balance: 400393223.68,
          ticker: 'VMSXX',
          securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
          shareQuantity: 8492203.03,
          settlementFund: true,
          securityType: SecurityType.MONEY_MARKET_FUND,
          restricted: false,
        },
      ],
    },
    {
      accountId: '933930914141253',
      accountName: 'Isabella Taylor — Brokerage Account — 37089792',
      productType: ProductType.BROKERAGE,
      serviceAgreementId: '722886914141253',
      balance: '776656.83',
      accountType: AANAccountType.INDIVIDUAL,
      registrationType: '00',
      registrationSubType: '00',
      accountNumber: '37089792',
      isBrokerage: true,
      cashManagementAccount: false,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '98935085740540',
          price: 1000.0,
          balance: 766049.32,
          ticker: 'VFIAX',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740541',
          price: 1000.0,
          balance: 6119.64,
          ticker: 'VWSUX',
          securityName: null as string,
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740542',
          price: 1000.0,
          balance: 207935.3,
          ticker: 'VWIUX',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740543',
          price: 1000.0,
          balance: 382117.18,
          ticker: 'VWLUX',
          securityName: null as unknown as string,
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
      ],
    },
    {
      accountId: '933930914141255',
      accountName: 'Isabella Taylor — Brokerage Account — 37089794',
      productType: ProductType.BROKERAGE,
      serviceAgreementId: '722886914141255',
      balance: '776656.83',
      accountType: AANAccountType.INDIVIDUAL,
      registrationType: '00',
      registrationSubType: '00',
      accountNumber: '37089794',
      isBrokerage: true,
      cashManagementAccount: true,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '98935085740540',
          price: 1000.0,
          balance: 766049.32,
          ticker: 'VFIAX',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740541',
          price: 1000.0,
          balance: 6119.64,
          ticker: 'VWSUX',
          securityName: null as unknown as string,
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740542',
          price: 1000.0,
          balance: 207935.3,
          ticker: 'VWIUX',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740543',
          price: 1000.0,
          balance: 382117.18,
          ticker: 'VWLUX',
          securityName: null as unknown as string,
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
      ],
    },
  ],
};

export const filteredIndividualClientAccount: FilteredClientAccount = {
  vgClientPoid: '123',
  accounts: [
    {
      accountId: '453930914141238',
      accountName: 'Isabella Taylor — Brokerage Account — 37089215',
      productType: ProductType.BROKERAGE,
      serviceAgreementId: '722886914141253',
      balance: '237445.83',
      accountType: AANAccountType.INDIVIDUAL,
      registrationType: '00',
      registrationSubType: '00',
      accountNumber: '37089215',
      isBrokerage: true,
      cashManagementAccount: false,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '108016914141254',
          price: 1000.0,
          balance: 2107.45,
          ticker: 'VMFXX',
          securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
          shareQuantity: 8492203.03,
          settlementFund: true,
          securityType: SecurityType.MONEY_MARKET_FUND,
          restricted: false,
        },
        {
          positionId: '318101929054956',
          price: 1000.0,
          balance: 45800.0,
          ticker: 'VPTXX',
          securityName: 'VANGUARD PENNSYLVANIA MUN MONEY MARKET INVESTOR CL',
          shareQuantity: 129.737,
          settlementFund: false,
          securityType: SecurityType.MONEY_MARKET_FUND,
          restricted: false,
        },
        {
          positionId: '413408911042734',
          price: 1000.0,
          balance: 727950.0,
          ticker: 'AAPL',
          securityName: 'APPLE',
          shareQuantity: 129.737,
          settlementFund: false,
          securityType: SecurityType.STOCK,
          restricted: false,
        },
        {
          positionId: '819820119053811',
          price: 1000.0,
          balance: 799.38,
          ticker: 'VTI',
          securityName: 'VANGUARD TOTAL STOCK MARKET ETF',
          shareQuantity: 129.737,
          settlementFund: false,
          securityType: SecurityType.ETF,
          restricted: false,
        },
      ],
    },
    {
      accountId: '933930914141253',
      accountName: 'Isabella Taylor — Brokerage Account — 37089792',
      productType: ProductType.BROKERAGE,
      serviceAgreementId: '722886914141253',
      balance: '776656.83',
      accountType: AANAccountType.INDIVIDUAL,
      registrationType: '00',
      registrationSubType: '00',
      accountNumber: '37089792',
      isBrokerage: true,
      cashManagementAccount: false,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '98935085740540',
          price: 1000.0,
          balance: 766049.32,
          ticker: 'VFIAX',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740541',
          price: 1000.0,
          balance: 6119.64,
          ticker: 'VWSUX',
          securityName: null as unknown as string,
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740542',
          price: 1000.0,
          balance: 207935.3,
          ticker: 'VWIUX',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740543',
          price: 1000.0,
          balance: 382117.18,
          ticker: 'VWLUX',
          securityName: null as unknown as string,
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
      ],
    },
  ],
};

export const filteredUTMAUGMAClientAccount: FilteredClientAccount = {
  vgClientPoid: '123',
  accounts: [
    {
      accountId: '531769325000502',
      accountName: 'Berry Buries, Bailey Buries Cust — UGMA Account',
      productType: ProductType.MUTUAL_FUND,
      serviceAgreementId: '378753325000502',
      balance: '1362221.44',
      accountType: AANAccountType.UGMA,
      registrationType: '04',
      registrationSubType: '78',
      accountNumber: '09893508574',
      cashManagementAccount: false,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '98935085740540',
          price: 1000.0,
          balance: 766049.32,
          ticker: 'VFIAX',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740541',
          price: 1000.0,
          balance: 6119.64,
          ticker: 'VWSUX',
          securityName: null as unknown as string,
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740542',
          price: 1000.0,
          balance: 207935.3,
          ticker: 'VWIUX',
          securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
        {
          positionId: '98935085740543',
          price: 1000.0,
          balance: 382117.18,
          ticker: 'VWLUX',
          securityName: null as unknown as string,
          shareQuantity: 0.0,
          vastAccountNumber: '09893508574',
          securityType: SecurityType.MUTUAL_FUND,
          restricted: false,
        },
      ],
      isBrokerage: false,
      registeredRoles: [],
    },
  ],
};

export const filteredTrustClientAccount: FilteredClientAccount = {
  vgClientPoid: '123',
  accounts: [
    {
      accountId: '933930914141253',
      accountName: 'Isabella Taylor — Brokerage Account — 37089792',
      productType: ProductType.BROKERAGE,
      serviceAgreementId: '722886914141253',
      balance: '776656.83',
      accountType: AANAccountType.LIVING_TRUST,
      registrationType: '00',
      registrationSubType: '00',
      accountNumber: '37089792',
      cashManagementAccount: false,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      restrictions: [],
      positions: [
        {
          positionId: '108016914141254',
          price: 1000.0,
          balance: 2107.45,
          ticker: 'VMFXX',
          securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
          shareQuantity: 8492203.03,
          settlementFund: true,
          securityType: SecurityType.MONEY_MARKET_FUND,
          restricted: false,
        },
        {
          positionId: '318101929054956',
          price: 1000.0,
          balance: 45800.0,
          ticker: 'VPTXX',
          securityName: 'VANGUARD PENNSYLVANIA MUN MONEY MARKET INVESTOR CL',
          shareQuantity: 129.737,
          settlementFund: false,
          securityType: SecurityType.MONEY_MARKET_FUND,
          restricted: false,
        },
        {
          positionId: '413408911042734',
          price: 1000.0,
          balance: 727950.0,
          ticker: 'AAPL',
          securityName: 'APPLE',
          shareQuantity: 129.737,
          settlementFund: false,
          securityType: SecurityType.STOCK,
          restricted: false,
        },
        {
          positionId: '819820119053811',
          price: 1000.0,
          balance: 799.38,
          ticker: 'VTI',
          securityName: 'VANGUARD TOTAL STOCK MARKET ETF',
          shareQuantity: 129.737,
          settlementFund: false,
          securityType: SecurityType.ETF,
          restricted: false,
        },
      ],
      isBrokerage: true,
      registeredRoles: [],
    },
  ],
};

export const filteredIneligibleITClientAccount: FilteredClientAccount = {
  vgClientPoid: '123',
  accounts: [
    {
      accountId: '887355828125120',
      accountName: 'Benjamin Price, Isabella Taylor',
      productType: ProductType.MUTUAL_FUND,
      isBrokerage: false,
      serviceAgreementId: '208298828125120',
      balance: '10.00',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      registrationType: '01',
      registrationSubType: '03',
      cashManagementAccount: false,
      accountNumber: '644232322',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: [],
      restrictions: [],
    },
    {
      accountId: '933930914141253',
      accountName: 'Isabella Taylor — 37089792',
      productType: ProductType.MUTUAL_FUND,
      serviceAgreementId: '722886914141253',
      balance: '776656.83',
      accountType: AANAccountType.INDIVIDUAL,
      registrationType: '00',
      registrationSubType: '00',
      accountNumber: '37089792',
      isBrokerage: true,
      cashManagementAccount: false,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: [],
      restrictions: [],
    },
    {
      accountId: '872374687237238732',
      accountName: 'Isabella Taylor — 32339792',
      productType: ProductType.MUTUAL_FUND,
      serviceAgreementId: '722886914141253',
      balance: '776656.83',
      accountType: AANAccountType.INDIVIDUAL,
      registrationType: '00',
      registrationSubType: '00',
      accountNumber: '37089792',
      isBrokerage: true,
      cashManagementAccount: false,
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: [],
      restrictions: [],
    },
  ],
};

export const eligibleMutualFundJointAccount: FilteredClientAccount = {
  vgClientPoid: '111111111',
  accounts: [
    {
      accountId: '887355828125120',
      accountName: 'Benjamin Price, Isabella Taylor',
      productType: ProductType.MUTUAL_FUND,
      isBrokerage: false,
      serviceAgreementId: '208298828125120',
      balance: '10.00',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      registrationType: '01',
      registrationSubType: '03',
      cashManagementAccount: false,
      accountNumber: '644',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: null,
      restrictions: [],
    },
  ],
};

export const eligibleBrokerageJointAccount: FilteredClientAccount = {
  vgClientPoid: '111111111',
  accounts: [
    {
      accountId: '',
      accountName: 'T Client1, T Client2 — Brokerage Account — 88888888',
      productType: ProductType.BROKERAGE,
      isBrokerage: true,
      serviceAgreementId: '111111111111111',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      balance: '99999.99',
      accountNumber: '88888888',
      cashManagementAccount: false,
      registrationType: '',
      registrationSubType: '',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: null as Position[],
      restrictions: [],
    },
  ],
};

export const eligibleBrokerageJointAccounts: FilteredClientAccount = {
  vgClientPoid: '111111111',
  accounts: [
    {
      accountId: '',
      accountName: 'T Client1, T Client2 — Brokerage Account — 88888888',
      productType: ProductType.BROKERAGE,
      isBrokerage: true,
      serviceAgreementId: '111111111111111',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      balance: '99999.99',
      accountNumber: '88888888',
      cashManagementAccount: false,
      registrationType: '',
      registrationSubType: '',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: null as unknown as Position[],
      restrictions: [],
    },
    {
      accountId: '',
      accountName: 'Isabella Taylor, Benjamin Price — Brokerage Account — 37089792',
      productType: ProductType.BROKERAGE,
      isBrokerage: true,
      serviceAgreementId: '722886914141254',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      balance: '300333.08',
      accountNumber: '123',
      cashManagementAccount: false,
      registrationType: '',
      registrationSubType: '',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: null as unknown as Position[],
      restrictions: [],
    },
    {
      accountId: '',
      accountName: 'Isabella Taylor, Benjamin Price — Brokerage Account — 37089792',
      productType: ProductType.BROKERAGE,
      isBrokerage: true,
      serviceAgreementId: '722886914141254',
      accountType: AANAccountType.JOINT_TENANTS_WROS,
      balance: '300333.08',
      accountNumber: '123',
      cashManagementAccount: false,
      registrationType: '',
      registrationSubType: '',
      balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
      managed: false,
      positions: null as unknown as Position[],
      restrictions: [],
    },
  ],
};

export const minorAccountStub: IClientAccounts['accounts'] = [
  {
    accountId: '849422127111247',
    accountName: 'Susan Walters, Jackie Walters Cust — UTMA Brokerage Account — 50024950',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '93504127111245',
    balance: '406955515.09',
    accountType: AANAccountType.UTMA,
    registrationType: '04',
    registrationSubType: '78',
    brokerageAccountNumber: '50024950',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '224665127130043',
        price: 1000.0,
        balance: 6562291.41,
        ticker: 'VGSTX',
        securityName: 'SOME COOL FUND',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '561793126032030',
        price: 1000.0,
        balance: 737620.0,
        ticker: 'TSLA',
        securityName: 'TESLA INC',
        shareQuantity: 342.03,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '287520127130043',
        price: 1000.0,
        balance: 400393223.68,
        ticker: 'VMSXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '531769325000502',
    accountName: 'Berry Buries, Bailey Buries Cust — UGMA Account',
    productType: ProductType.MUTUAL_FUND,
    serviceAgreementId: '378753325000502',
    balance: '1362221.44',
    accountType: AANAccountType.UGMA,
    registrationType: '04',
    registrationSubType: '78',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '98935085740540',
        price: 1000.0,
        balance: 766049.32,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 0.0,
        vastAccountNumber: '09893508574',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '98935085740541',
        price: 1000.0,
        balance: 6119.64,
        ticker: 'VWSUX',
        securityName: null as unknown as string,
        shareQuantity: 0.0,
        vastAccountNumber: '09893508574',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '98935085740542',
        price: 1000.0,
        balance: 207935.3,
        ticker: 'VWIUX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 0.0,
        vastAccountNumber: '09893508574',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '98935085740543',
        price: 1000.0,
        balance: 382117.18,
        ticker: 'VWLUX',
        securityName: null as unknown as string,
        shareQuantity: 0.0,
        vastAccountNumber: '09893508574',
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
    ],
  },
];

export const minorServiceStub: IClientAccounts['serviceAgreements'] = [
  {
    serviceAgreementId: 93504127111245,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        roleType: 'SHMN00',
        permissionType: 'VIEW00',
        primaryOwner: false,
        authorizedSigner: false,
        poid: 111111111,
      },
      {
        roleType: 'CUCU01',
        permissionType: 'TRNS01',
        primaryOwner: true,
        authorizedSigner: true,
        poid: 1992297642,
      },
    ],
  },
  {
    serviceAgreementId: 378753325000502,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        roleType: 'SHMN10',
        permissionType: 'VIEW10',
        primaryOwner: true,
        authorizedSigner: false,
        poid: 111111111,
      },
      {
        roleType: 'CUCU11',
        permissionType: 'TRNS11',
        primaryOwner: false,
        authorizedSigner: true,
        poid: 1992297642,
      },
    ],
  },
];

export const minorClientAccountTestStub: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: minorAccountStub,
  serviceAgreements: minorServiceStub,
};

export const nonSelectedAccount: ISelectedAccount[] = [
  {
    index: '0',
    accountNumber: null as string,
    accountData: null as FilteredAccount,
  },
];

export const selectedBrokerageAccount: ISelectedAccount[] = [
  {
    index: '0',
    accountNumber: '88888888',
    accountData: eligibleBrokerageJointAccount.accounts[0],
  },
];

export const formattedBrokerageAccount: ISelectedAccount[] = [
  {
    index: '0',
    accountNumber: '88888888',
    accountData: eligibleBrokerageJointAccounts.accounts[1],
  },
];

export const selectedBrokerageAccounts: ISelectedAccount[] = [
  {
    index: '0',
    accountNumber: '88888888',
    accountData: eligibleBrokerageJointAccount.accounts[0],
  },
  {
    index: '1',
    accountNumber: '88888888',
    accountData: eligibleBrokerageJointAccount.accounts[0],
  },
];

export const selectedMutualAccount: ISelectedAccount[] = [
  {
    index: '0',
    accountNumber: '88270915280',
    accountData: eligibleMutualFundJointAccount.accounts[0],
  },
];

export const selectedMutualAccounts: ISelectedAccount[] = [
  {
    index: '0',
    accountNumber: '88270915280',
    accountData: eligibleMutualFundJointAccount.accounts[0],
  },
  {
    index: '1',
    accountNumber: '88270915280',
    accountData: eligibleMutualFundJointAccount.accounts[0],
  },
];

export const selectedMixedAccount: ISelectedAccount[] = [
  {
    index: '0',
    accountNumber: '88270915280',
    accountData: filteredJointClientAccount.accounts[0],
  },
  {
    index: '1',
    accountNumber: '88888888',
    accountData: filteredJointClientAccount.accounts[1],
  },
];

export const nicknamedJointAccount: ISelectedAccount[] = [
  {
    index: '0',
    accountNumber: '88270915280',
    accountData: {
      ...filteredJointClientAccount.accounts[0],
      nickname: 'Let freedom ring',
    },
  },
];

export const trustAccountStub: IClientAccounts['accounts'] = [
  {
    accountId: '245592816134454',
    accountName: 'Isabella Taylor',
    productType: ProductType.MUTUAL_FUND,
    serviceAgreementId: '73569816134454',
    balance: '410136.69',
    accountType: AANAccountType.LIVING_TRUST,
    registrationType: '00',
    registrationSubType: '00',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '883743523670033',
        price: 1000.0,
        balance: 386732.42,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        vastAccountNumber: '88374352367',
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '883743523670540',
        price: 1000.0,
        balance: 23404.27,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 129.737,
        vastAccountNumber: '88374352367',
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '933930914141253',
    accountName: 'Isabella Taylor — Brokerage Account — 37089792',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '722886914141253',
    balance: '776656.83',
    accountType: AANAccountType.LIVING_TRUST,
    registrationType: '00',
    registrationSubType: '00',
    brokerageAccountNumber: '37089792',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '108016914141254',
        price: 1000.0,
        balance: 2107.45,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '318101929054956',
        price: 1000.0,
        balance: 45800.0,
        ticker: 'VPTXX',
        securityName: 'VANGUARD PENNSYLVANIA MUN MONEY MARKET INVESTOR CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '413408911042734',
        price: 1000.0,
        balance: 727950.0,
        ticker: 'AAPL',
        securityName: 'APPLE',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.STOCK,
        restricted: false,
      },
      {
        positionId: '819820119053811',
        price: 1000.0,
        balance: 799.38,
        ticker: 'VTI',
        securityName: 'VANGUARD TOTAL STOCK MARKET ETF',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.ETF,
        restricted: false,
      },
    ],
  },
  {
    accountId: '494446104144543',
    accountName: 'Isabella Taylor — Roth IRA Brokerage Account — 60917441',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '469090808101044',
    balance: '2251.48',
    accountType: AANAccountType.ROTH_IRA,
    registrationType: '00',
    registrationSubType: '47',
    brokerageAccountNumber: '60917441',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '59240120034314',
        price: 1000.0,
        balance: 13.36,
        ticker: 'EIISX',
        securityName: 'SOME COOL FUN',
        shareQuantity: 342.03,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '826290120112416',
        price: 1000.0,
        balance: 2232.06,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '967514104144543',
        price: 1000.0,
        balance: 6.06,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
];

export const estateAccountStub: IClientAccounts['accounts'] = [
  {
    accountId: '245592816134454',
    accountName: 'Isabella Taylor',
    productType: ProductType.MUTUAL_FUND,
    serviceAgreementId: '73569816134454',
    balance: '410136.69',
    accountType: AANAccountType.ESTATE,
    registrationType: '00',
    registrationSubType: '00',
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '883743523670033',
        price: 1000.0,
        balance: 386732.42,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        vastAccountNumber: '88374352367',
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '883743523670540',
        price: 1000.0,
        balance: 23404.27,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 129.737,
        vastAccountNumber: '88374352367',
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
  {
    accountId: '933930914141253',
    accountName: 'Isabella Taylor — Brokerage Account — 37089792',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '722886914141253',
    balance: '776656.83',
    accountType: AANAccountType.ESTATE,
    registrationType: '00',
    registrationSubType: '00',
    brokerageAccountNumber: '37089792',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '108016914141254',
        price: 1000.0,
        balance: 2107.45,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '318101929054956',
        price: 1000.0,
        balance: 45800.0,
        ticker: 'VPTXX',
        securityName: 'VANGUARD PENNSYLVANIA MUN MONEY MARKET INVESTOR CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
      {
        positionId: '413408911042734',
        price: 1000.0,
        balance: 727950.0,
        ticker: 'AAPL',
        securityName: 'APPLE',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.STOCK,
        restricted: false,
      },
      {
        positionId: '819820119053811',
        price: 1000.0,
        balance: 799.38,
        ticker: 'VTI',
        securityName: 'VANGUARD TOTAL STOCK MARKET ETF',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.ETF,
        restricted: false,
      },
    ],
  },
  {
    accountId: '494446104144543',
    accountName: 'Isabella Taylor — Roth IRA Brokerage Account — 60917441',
    productType: ProductType.BROKERAGE,
    serviceAgreementId: '469090808101044',
    balance: '2251.48',
    accountType: AANAccountType.ESTATE,
    registrationType: '00',
    registrationSubType: '47',
    brokerageAccountNumber: '60917441',
    cashManagementAccount: false,
    balanceAsOfDateTime: '2022-08-03T16:00:00.000-0400',
    managed: false,
    optionPermission: OptionPermission.NO_PAPERS,
    marginCode: MarginCode.CASH,
    restrictions: [],
    positions: [
      {
        positionId: '59240120034314',
        price: 1000.0,
        balance: 13.36,
        ticker: 'EIISX',
        securityName: 'SOME COOL FUN',
        shareQuantity: 342.03,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '826290120112416',
        price: 1000.0,
        balance: 2232.06,
        ticker: 'VFIAX',
        securityName: 'VANGUARD 500 INDEX ADMIRAL CL',
        shareQuantity: 129.737,
        settlementFund: false,
        securityType: SecurityType.MUTUAL_FUND,
        restricted: false,
      },
      {
        positionId: '967514104144543',
        price: 1000.0,
        balance: 6.06,
        ticker: 'VMFXX',
        securityName: 'VANGUARD FEDERAL MONEY MARKET FUND',
        shareQuantity: 8492203.03,
        settlementFund: true,
        securityType: SecurityType.MONEY_MARKET_FUND,
        restricted: false,
      },
    ],
  },
];

export const trustServiceStub: IClientAccounts['serviceAgreements'] = [
  {
    serviceAgreementId: 73569816134454,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH0',
        permissionType: 'TRNS0',
        primaryOwner: true,
        authorizedSigner: true,
      },
      {
        poid: 111111111,
        roleType: 'TRTR',
        permissionType: 'TRNS0',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 469090808101044,
    serviceId: '38',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH1',
        permissionType: 'TRNS1',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
  {
    serviceAgreementId: 722886914141253,
    serviceId: '90',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH2',
        permissionType: 'TRNS2',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
];

export const trustServiceStubWithNoTrustee: IClientAccounts['serviceAgreements'] = [
  {
    serviceAgreementId: 73569816134454,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH0',
        permissionType: 'TRNS0',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },

  {
    serviceAgreementId: 722886914141253,
    serviceId: '90',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH2',
        permissionType: 'TRNS2',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
];

export const estateServiceStubWithNoExecutor: IClientAccounts['serviceAgreements'] = [
  {
    serviceAgreementId: 73569816134454,
    serviceId: '8',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH0',
        permissionType: 'TRNS0',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },

  {
    serviceAgreementId: 722886914141253,
    serviceId: '90',
    effectiveEndDate: new Date('9999-12-31'),
    grantedRoles: [],
    registeredRoles: [
      {
        poid: 111111111,
        roleType: 'SHSH2',
        permissionType: 'TRNS2',
        primaryOwner: true,
        authorizedSigner: true,
      },
    ],
  },
];

export const trustClientAccountTestStubNoTrustee: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: trustAccountStub,
  serviceAgreements: trustServiceStubWithNoTrustee,
};

export const trustClientAccountTestStub: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: trustAccountStub,
  serviceAgreements: trustServiceStub,
};

export const executorClientAccountTestStub: IClientAccounts = {
  vgClientPoid: '111111111',
  accounts: estateAccountStub,
  serviceAgreements: estateServiceStubWithNoExecutor,
};
